import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_FBP_ASSIGN);

const _pk_name = "id";

const state = {
    data: [],
    exits: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setExits: (state, payload) => {
        if (payload) {
            state.exits = payload;
        }
        //console.log('fetched exits', state.exits)
    },

    addEmployee: (state, payload) => {
        //console.log('payload data from store', payload)
        state.exits = payload;
        //console.log('exit data', state.exits);
        //console.log('state data', state.data);
        // state.data.push(payload);
    },

    //   updateEmployeeById: (state, payload) => {
    //     for(let i=0; i<state.data.length; i++) {
    //       if(state.data[i][_pk_name] === payload.id) {
    //         state.data.splice(i, 1, payload);
    //       }
    //     }
    //   },

    //   removeEmployeeById: (state, payload) => {
    //     for (let i=0; i<state.data.length; i++){
    //       if (state.data[i][_pk_name] == payload){
    //         state.data.splice(i, 1);
    //       }
    //     }
    //   },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
    async fetchAll({ commit }, payload) {
        //console.log("[state/payroll/fbp/assign/fetchAll] Calling API...");
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`);
            commit("setFetching", false);
            //console.log("[state/payroll/fbp/assign/fetchAll] res: ", res);
            if (res.status == 200) {
                commit("set", payload);
            }
            return res;
        } catch {

        }
    },


    async create({ commit }, payload) {
        //console.log("[state/payroll/fbp/assign/create] Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            //console.log("[state/payroll/fbp/assign/create] res: ", res);
            if (res.status == 200) {
                commit("addEmployee", payload);
            }
            return res;
        } catch {

        }
    },

    async update({ commit }, payload) {
        //console.log("[state/payroll/fbp/assign/update] Updating... Display payload", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.id}`, payload);
            commit("setSaving", false);
            //console.log("[state/payroll/fbp/assign/update] res: ", res);
            if (res.status == 200) {
                commit("updateEmployeeById", res.data);
            }
            return res;
        } catch {

        }
    },

    async delete({ commit }, payload) {
        //console.log("[state/payroll/fbp/assign/delete] Payload:", payload);
        //console.log("[state/payroll/fbp/assign/delete] Payload:", `/${payload.id}`);
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEmployeeById", payload.id);
            }
        } catch {

        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}